import React from 'react'
import { Navigate, Route } from 'react-router-dom'
import { Welcome } from '../pages/onboarding/welcome/Welcome'
import { Location } from '../pages/onboarding/location/Location'
import { Extension } from '../pages/onboarding/extension/Extension'
import { RequestLicenses } from '../pages/onboarding/request-licenses/RequestLicenses'
import { WorkingHours } from '../pages/onboarding/working-hours/WorkingHours'
import { SentryRouter } from './components/SentryRouter'
import { routes } from './routes'
import { shouldShowRequestLicenses } from '@/pages/onboarding/welcome/helpers'

export const OnboardingRoutes = () => (
  <SentryRouter>
    <Route path={routes.onboarding.index}>
      <Route index element={<Welcome />} />
      <Route path={routes.onboarding.workingHours} element={<WorkingHours />} />
      {shouldShowRequestLicenses() && (
        <Route path={routes.onboarding.requestLicenses} element={<RequestLicenses />} />
      )}
      <Route path={routes.onboarding.location} element={<Location />} />
      <Route path={routes.onboarding.extension} element={<Extension />} />
    </Route>
    <Route path='*' element={<Navigate to={routes.onboarding.index} />} />
  </SentryRouter>
)
